import BaseMygocuApiService from './BaseMygocuApiService';

const SEGURIDAD_API_BASEPATH_URL = '';

class LoginApiService {
  login(mail, password) {
    return BaseMygocuApiService.post(SEGURIDAD_API_BASEPATH_URL.concat('/login_check'), {
      username: mail,
      password,
    });
  }

  loginGoogle(token) {
    return BaseMygocuApiService.post(SEGURIDAD_API_BASEPATH_URL.concat('/login_google_check'), null, null, {
      Authorization: `Bearer ${token}`,
    });
  }
}

export default new LoginApiService();
